export const tourId = "editor-first-visit";

export const steps = [
  {
    title: "Welcome to the Editor",
    target: "#switch-page-menu-btn",
    content: "Switch between pages here.",
    disableBeacon: true,
  },
  {
    target: "#publish-menu-btn",
    content: "This another awesome feature",
    disableBeacon: true,
  },
  {
    target: "img[alt='Upstart']",
    content: "Go back to dashboard",
    disableBeacon: true,
  },
];
